"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _InputConstants = require("./InputConstants");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _IMESafe = _interopRequireDefault(require("../decorators/IMESafe"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _Functions = require("../core/Functions");

var _FieldsetContext = require("../context/FieldsetContext");

var TYPES = ['text', 'email', 'number', 'password', 'search', 'url'];

var UITextInput = _react.default.createClass({
  displayName: "UITextInput",
  propTypes: {
    defaultValue: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    inputRef: _refObject.default,
    onChange: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType.default)(_react.PropTypes.string),
    readOnly: _react.PropTypes.bool,
    styled: _react.PropTypes.bool.isRequired,
    type: _react.PropTypes.oneOf(TYPES),
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      styled: true,
      type: 'text'
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        error = _this$props.error,
        inputRef = _this$props.inputRef,
        placeholder = _this$props.placeholder,
        styled = _this$props.styled,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "error", "inputRef", "placeholder", "styled", "use"]);
    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
      var fieldSize = _ref.size;
      return _react.default.createElement("input", (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('form-control private-form__control', _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], className, {
          'private-form__control--unstyled uiTextInputUnstyled': !styled,
          'private-form__control--error': error
        }, _InputConstants.USE_CLASSES[use]),
        placeholder: (0, _lazyEval.default)(placeholder),
        ref: (0, _Functions.wrapRefObject)(inputRef)
      }));
    });
  }
});

var _default = (0, _ShareInput.default)((0, _IMESafe.default)(UITextInput));

exports.default = _default;
module.exports = exports.default;